// Импорт библиотек из node_modules
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Modal, Ripple, Collapse, initTWE } from "tw-elements";

var ipad_width = 992,
    mobile_width = 768;

(function ($) {
    "use strict";

    $(document).ready(function () {

        /*******************************************/
        /* Header */
        /*******************************************/

        $(window).scroll(function() {
            var scrollTop = $(this).scrollTop();
            const $header = $('.header-wrapper');

            if (scrollTop > 50) {
                $header.removeClass('bg-transparent').addClass('scrolled');
            } else {
                $header.removeClass('scrolled').addClass('bg-transparent');
            }
        });

        // Mobile Menu Toggle
        $('.hamburger-menu').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).toggleClass('is-active');
            $('.mobile-menu').toggleClass('is-active');
            $('body').toggleClass('menu-open');
        });

        // Close mobile menu when clicking on overlay
        $('body').on('click', function(e) {
            if ($('body').hasClass('menu-open') && !$(e.target).closest('.mobile-menu, .hamburger-menu').length) {
                $('.hamburger-menu').removeClass('is-active');
                $('.mobile-menu').removeClass('is-active');
                $('body').removeClass('menu-open');
            }
        });

        // Close mobile menu on window resize
        $(window).on('resize', function() {
            if ($(window).width() >= 1024) {
                $('.hamburger-menu').removeClass('is-active');
                $('.mobile-menu').removeClass('is-active');
                $('body').removeClass('menu-open');
            }
        });

        // Close button
        $('.mobile-menu-close').on('click', function() {
            $('.hamburger-menu').removeClass('is-active');
            $('.mobile-menu').removeClass('is-active');
            $('body').removeClass('menu-open');
        });

        // Accordion — sub-menu toggle
        $('.mobile-menu .menu-item-has-children > a').on('click', function(e) {
            e.preventDefault();
            const $li = $(this).closest('.menu-item-has-children');
            const $subMenu = $li.find('> .sub-menu');
            const isOpen = $li.hasClass('is-open');

            // Close all other open items
            $('.mobile-menu .menu-item-has-children.is-open').not($li).removeClass('is-open').find('> .sub-menu').slideUp(250);

            $li.toggleClass('is-open', !isOpen);
            $subMenu.slideToggle(250);
        });

        /*******************************************/
        /* Slick sliders */
        /*******************************************/

        const textDirection = $("html").attr("dir");

        if ($('.floor3-slider').length) {
            $('.floor3-slider').slick({
                rtl: true,
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                prevArrow: $('.floor3-arrow--prev'),
                nextArrow: $('.floor3-arrow--next'),
                responsive: [
                    { breakpoint: 1500, settings: { slidesToShow: 4 } },
                    { breakpoint: 1280, settings: { slidesToShow: 3 } },
                    { breakpoint: 1024, settings: { slidesToShow: 2 } },
                    { breakpoint: 640,  settings: { slidesToShow: 1 } }
                ]
            });
        }

        if ($('.js-testimonials-slider').length) {
            $('.js-testimonials-slider').slick({
                rtl: textDirection === "rtl",
                speed: 25000,
                autoplay: true,
                autoplaySpeed: 0,
                cssEase: 'linear',
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                arrows: false,
                dots: false,
                responsive: [ 
                    {
                        breakpoint: 992,
                        settings: {slidesToShow: 2, speed: 10000, }
                    },
                    {
                        breakpoint: 767,
                        settings: { slidesToShow: 1, speed: 10000 }
                    }
                ]
            });
        }

        if ($('.js-latest-posts-slider').length) {
            $('.js-latest-posts-slider').slick({
                rtl: true,
                arrows: true,
                dots: false,
                slidesToScroll: 1,
                slidesToShow: 4,
                infinite: true,
                nextArrow: $('.floor8-arrow--next'),
                prevArrow: $('.floor8-arrow--prev'),
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: { slidesToShow: 3, slidesToScroll: 1 }
                    },
                    {
                        breakpoint: 1200,
                        settings: { slidesToShow: 2, slidesToScroll: 1 }
                    },
                    {
                        breakpoint: 992,
                        settings: { arrows: false, slidesToShow: 2, slidesToScroll: 1 }
                    },
                    {
                        breakpoint: 767,
                        settings: { arrows: false, slidesToShow: 1, slidesToScroll: 1 }
                    }
                ]
            });
        }

        if ($('.js-main-slider-rtl').length) {
            $('.js-main-slider-rtl').slick({
                speed: 9000,
                autoplay: true,
                autoplaySpeed: 0,
                cssEase: 'linear',
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true,
                arrows: false,
                dots: false,
            });
        }

        if ($('.js-related-posts').length) {
            $('.js-related-posts').slick({
                rtl: true,
                arrows: true,
                dots: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                nextArrow: '<i class="icon-nav-left icon-s y-align cursor-pointer z-index-2 w-auto pos-l-n4 text-color-1"></i>',
                prevArrow: '<i class="icon-nav-right icon-s y-align cursor-pointer z-index-2 w-auto pos-r-n4 text-color-1"></i>',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: { slidesToShow: 2, arrows: false }
                    },
                    {
                        breakpoint: 768,
                        settings: { slidesToShow: 1, arrows: false }
                    }
                ]
            });
        }

        $('.js-team-slider').slick({
            rtl: true,
            arrows: false,
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            nextArrow: '<i class="icon-nav-left icon-s y-align cursor-pointer z-index-2 w-auto pos-l-n4 text-color-1"></i>',
            prevArrow: '<i class="icon-nav-right icon-s y-align cursor-pointer z-index-2 w-auto pos-r-n4 text-color-1"></i>',

            responsive: [
                {
                    breakpoint: 9999,
                    settings: "unslick"
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                    }
                }
            ]
        });

        /*******************************************/
        /* AOS - MUST INIT AFTER SLICK! */
        /*******************************************/

        AOS.init({
            offset: 200,
            duration: 1000,
        });

        /*******************************************/
        /* Floor 2 — Parallax */
        /*******************************************/

        if ($('#homepage-floor2').length) {
            var lerp = function (a, b, t) {
                return a + (b - a) * Math.min(Math.max(t, 0), 1);
            };
            var updateFloor2 = function () {
                var rect = document.getElementById('homepage-floor2').getBoundingClientRect();
                var t = 1 - (rect.top / window.innerHeight);
                $('#floor2-photo-card').css({ left: lerp(180, 140, t) + 'px', top:    lerp(140, 170, t) + 'px' });
                $('#floor2-card1').css({     top:   lerp(200, 150, t) + 'px', right:  lerp(205, 105, t) + 'px' });
                $('#floor2-card2').css({     bottom: lerp(50,  80,  t) + 'px', right: lerp(356, 256, t) + 'px' });
            };
            var floor2Ticking = false;
            window.addEventListener('scroll', function () {
                if (!floor2Ticking) {
                    requestAnimationFrame(function () {
                        updateFloor2();
                        floor2Ticking = false;
                    });
                    floor2Ticking = true;
                }
            }, { passive: true });
            updateFloor2();
        }

        /*******************************************/
        /* TW Elements Initialization */
        /*******************************************/

        // Импорт и инициализация TW Elements для модального окна


// Инициализация TW Elements с Modal и Ripple
        initTWE({ Modal, Ripple, Collapse });
        console.log('TW Elements Modal инициализирован');


        /*******************************************/
        /* BLOG */
        /*******************************************/

        $('.blog-cat').on('click', function () {
            $('.blog-cat').removeClass('current-cat');
            $(this).addClass('current-cat');
        })
        $('#post-category-select').on('change', function () {
            location = $(this).val();
        });

        $('#search-id').click(function () {
            $(this).closest('form').submit();
        });

        $('.js-blog-cats-slider').slick({
            rtl: true,
            arrows: true,
            dots: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            centerMode: true,
            variableWidth: true,
            nextArrow: '<i class="blog-cat-next icon-circle-left cursor-pointer"></i>',
            prevArrow: '<i class="blog-cat-prev icon-circle-right cursor-pointer"></i>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        variableWidth: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        variableWidth: true,
                    }
                }
            ]
        });

        /*******************************************/
        /* Video */
        /*******************************************/

        $('.video-cubic').click(function () {
            $(this).html($(this).data('iframe')).css('background', 'none');
        });

        /*******************************************/
        /* CF7 */
        /*******************************************/

        document.addEventListener('wpcf7mailsent', function (event) {
            location.href = sogoc.thank_you_page;
        }, false);

        /*******************************************/
        /* COUNTER */
        /*******************************************/
        if ($('#counter-box').length) {
            var a = 0;
            $(window).scroll(function () {
                var oTop = $("#counter-box").offset().top - window.innerHeight;
                if (a == 0 && $(window).scrollTop() > oTop) {
                    $(".counter").each(function () {
                        var $this = $(this),
                            countTo = $this.attr("data-number");
                        $({
                            countNum: $this.text()
                        }).animate(
                            {countNum: countTo},
                            {
                                duration: 4000,
                                easing: "swing",
                                step: function () {
                                    $this.text(
                                        Math.ceil(this.countNum).toLocaleString('en')
                                    );
                                },
                                complete: function () {
                                    $this.text(
                                        Math.ceil(this.countNum).toLocaleString('en')
                                    );
                                }
                            }
                        );
                    });
                    a = 1;
                }
            });
        }


        /*******************************************/
        /* Floor 5 — Advantage cards */
        /*******************************************/

        $('.floor5-card').on('click', function () {
            $('.floor5-card').removeClass('floor5-card--active');
            $(this).addClass('floor5-card--active');
        });

        /*******************************************/
        /* FAQ accordion */
        /*******************************************/

        $('.faq-question').on('click', function () {
            var $item   = $(this).closest('.faq-item');
            var $answer = $item.find('.faq-answer');
            var isOpen  = $item.hasClass('faq-item--open');

            $('.faq-item').removeClass('faq-item--open');
            $('.faq-answer').slideUp(200);
            $('.faq-question').attr('aria-expanded', 'false');

            if (!isOpen) {
                $item.addClass('faq-item--open');
                $answer.slideDown(200);
                $(this).attr('aria-expanded', 'true');
            }
        });

/*******************************************/
        /* About — section nav scroll spy */
        /*******************************************/

        if ($('#section-nav').length) {
            var $nav       = $('#section-nav');
            var $headers   = $('h2[id]');
            var isScrolling = false;

            $headers.each(function () {
                var $link = $('<button>', {
                    class:         'section-link w-full p-4 not-active',
                    text:          $(this).text(),
                    'data-target': $(this).attr('id')
                });
                $nav.append($link);
            });

            var updateActiveSection = function () {
                if (isScrolling) return;
                var current   = '';
                var scrollTop = $(window).scrollTop();
                $headers.each(function () {
                    if (scrollTop >= $(this).offset().top - 150) {
                        current = $(this).attr('id');
                    }
                });
                if (current) {
                    $('.section-link').removeClass('active').addClass('not-active');
                    $('[data-target="' + current + '"]').removeClass('not-active').addClass('active');
                }
            };

            $nav.on('click', '.section-link', function (e) {
                e.preventDefault();
                var targetId = $(this).data('target');
                isScrolling  = true;
                $('.section-link').removeClass('active').addClass('not-active');
                $(this).addClass('active').removeClass('not-active');
                $('html, body').animate({
                    scrollTop: $('#' + targetId).offset().top - 150
                }, 600, function () {
                    setTimeout(function () { isScrolling = false; }, 100);
                });
            });

            var navTicking = false;
            window.addEventListener('scroll', function () {
                if (!navTicking) {
                    requestAnimationFrame(function () {
                        updateActiveSection();
                        navTicking = false;
                    });
                    navTicking = true;
                }
            }, { passive: true });

            setTimeout(function () { updateActiveSection(); }, 100);
        }

    });


})(jQuery);